import { Component, ViewChild, AfterViewInit, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { CommonModule, DatePipe } from '@angular/common';
import {
  MatCheckboxChange,
  MatCheckboxModule,
} from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule } from '@angular/forms';
import { HeaderComponent } from '../../shared/header/header.component';
import { StepperComponent } from '../../shared/stepper/stepper.component';
import { FooterComponent } from '../../shared/footer/footer.component';
import { MatTableModule } from '@angular/material/table';
import { EmployeeDataService } from '../../shared/services/employee-data.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { UrlReferenceService } from '../../shared/services/url-reference.service';
import { ToastrService } from 'ngx-toastr';
import { CompanyService } from '../../shared/services/company.service';
import { LoaderService } from '../../shared/services/loader.service';
import { filter, finalize } from 'rxjs';
import { FilterPipe } from '../../pipes/filter.pipe';
import { forkJoin } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { EmployeeEditComponent } from '../../components/dialog/employee-edit/employee-edit.component';
import e from 'cors';
import {
  ApiDependent,
  ApiEmployee,
  Member,
  MemberData,
} from '../../models/employee.data.interface';
import { TranslateModule } from '@ngx-translate/core';
import { InsuranceClassPipe } from '../../pipes/insurance-class.pipe';
import { QuotaTriggerService } from '../../shared/services/quota-trigger.service';

FilterPipe;

@Component({
  selector: 'app-employee-details',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatSortModule,
    MatCheckboxModule,
    MatSelectModule,
    MatIconModule,
    MatButtonModule,
    MatTableModule,
    FooterComponent,
    HeaderComponent,
    FilterPipe,
    TranslateModule,
    InsuranceClassPipe,
  ],
  templateUrl: './employee-details.component.html',
  styleUrl: './employee-details.component.scss',
  providers: [DatePipe],
})
export class EmployeeDetailsComponent implements OnInit, AfterViewInit {
  [x: string]: any;
  tableData: Member[] = [];
  dataSource = new MatTableDataSource<Member>();
  displayedColumns: string[] = [
    'select',
    'id',
    'dateOfBirth',
    'gender',
    'mobileNumber',
    'insuranceClass',
    'options',
  ];
  insuranceClasses: string[] = ['A', 'B', 'C', 'VIP', 'Basic'];
  activeStep = 4;
  isActive: boolean = false;
  @ViewChild(MatSort) sort!: MatSort;

  selectedRowIndex: number | null = null;
  selectedDependentIndex: number | null = null;
  showOptionsModal = false;
  showAddDependentModal = false;
  modalPosition = { top: '0px', left: '0px' };
  selectedItems: Member[] = [];
  editedRowIndex: number | null = null;
  originalRowData: Member | null = null;
  currentPage = 0;
  pageSize = 10;
  totalPages = 0;
  totalElements = 0;
  private companyId: string = '';
  isDashboard: boolean = false;
  private sub: any;
  constructor(
    private http: HttpClient,
    private urlReferenceService: UrlReferenceService,
    private datePipe: DatePipe,
    private employeeDataService: EmployeeDataService,
    private router: Router,
    private toastr: ToastrService,
    private companyService: CompanyService,
    private loaderService: LoaderService,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private quotaTriggerService: QuotaTriggerService
  ) {}

  ngOnInit() {
    this.sub = this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe((e) => {
        const url = e.urlAfterRedirects || e.url;
        this.isDashboard = url.includes('/dashboard');
      });
    const initial = this.router.url;
    this.isDashboard = initial.includes('/dashboard');
    // Get companyId from query parameters first, then localStorage
    this.companyId =
      this.route.snapshot.queryParamMap.get('companyId') ||
      localStorage.getItem('companyId') ||
      '';

    console.log('Company ID from route:', this.companyId);
    this.fetchEmployeeData();
    const data = this.route.snapshot.data;
    this.isActive = !!data['isActive'];
    console.log('Is Active:', this.isActive);
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
  }

  private fetchEmployeeData(): void {
    this.loaderService.show();
    if (this.companyId === undefined) {
      this.toastr.error('Company ID is not available');
      this.loaderService.hide();
    } else {
      this.employeeDataService
        .getEmployeeDataPaged(
          this.companyId.toString(),
          this.currentPage,
          this.pageSize
        )
        .pipe(finalize(() => this.loaderService.hide()))
        .subscribe({
          next: (response: any) => {
            this.processApiResponse(response.content);
            this.totalPages = response.totalPages;
            this.totalElements = response.totalElements;
            this.currentPage = response.number;
            this.employeeDataService.employeeData = this.tableData;
            this.dataSource.data = this.tableData;
          },
          error: (err: any) => {
            console.error('Failed to fetch employee data:', err);
            this.toastr.error('Failed to fetch employee data');
          },
        });
    }
  }

  findIndex(id: string | number): number {
    return this.tableData.findIndex((item) => item.idNumber === id);
  }

  private processApiResponse(response: MemberData): void {
    const employees = response.employee || [];

    const transformedEmployees = employees.map((emp) =>
      this.transformEmployeeToMember(emp)
    );

    this.tableData = [...transformedEmployees];

    console.log('Transformed Table Data:', this.tableData);
  }

  private transformEmployeeToMember(employee: ApiEmployee): Member {
    return {
      id: employee.id,
      idNumber: employee.idNumber,
      firstNameEn: employee.firstNameEn || '',
      lastNameEn: employee.lastNameEn || '',

      nameArabic: employee.nameArabic || '',
      dateOfBirth: employee.dateOfBirth,
      jobTitle: employee.jobTitle || '',
      sponsorId: employee.sponsorId || '',
      gender: employee.gender,
      mobileNumber: employee.mobileNumber,
      insuranceClass: employee.insuranceClass,
      married: employee.married,
      declarationCompleted: employee.declarationCompleted,
      dependentList: this.transformDependentToMember(employee.dependentList),
      type: 'Employee',
    };
  }

  private transformDependentToMember(dependentList: any): ApiDependent[] {
    if (!Array.isArray(dependentList)) return [];
    return dependentList.map((dependent: any) => ({
      id: dependent.id,
      idNumber: dependent.idNumber,
      dateOfBirth: dependent.dateOfBirth,
      gender: dependent.gender,
      insuranceClass: dependent.insuranceClass,
      declarationCompleted: dependent.declarationCompleted,
      married: dependent.married,
      employeeId: dependent.employeeId,
      relation: dependent.relation,
      firstNameEn: dependent.firstNameEn || '',
      lastNameEn: dependent.lastNameEn || '',
      nameArabic: dependent.nameAr,
      mobileNumber: dependent.mobileNumber,
      type: 'Dependent',
    }));
  }

  applyFilters() {
    // Implement filter logic if needed
  }

  deleteSelected(): void {
    const idsToDelete: Map<string, string> = new Map(
      this.selectedItems.map((item) => [
        String(item.id),
        item.type.toLocaleLowerCase(),
      ])
    );

    if (idsToDelete.size === 0) return;

    this.loaderService.show();

    this.employeeDataService
      .deleteSelectedMembers(this.companyId, idsToDelete)
      .subscribe({
        next: () => {
          this.tableData = this.tableData.filter(
            (item) => !this.selectedItems.includes(item)
          );
          this.dataSource.data = this.tableData;
          this.selectedItems = [];
          this.fetchEmployeeData();
          this.toastr.success('Selected items deleted successfully');
        },
        error: (err: any) => {
          console.error('Delete failed:', err);
          this.toastr.error('Failed to delete selected items');
        },
        complete: () => {
          this.loaderService.hide();
        },
      });
  }

  deleteItem(index: number, dependentIndex: number | null = null): void {
    const item =
      dependentIndex != null && this.tableData[index].dependentList
        ? this.tableData[index].dependentList[dependentIndex]
        : this.tableData[index];

    const itemType = dependentIndex != null ? 'dependent' : 'employee';

    this.loaderService.show();

    this.employeeDataService
      .deleteSingleMember(this.companyId, itemType, item.id)
      .subscribe({
        next: () => {
          this.tableData.splice(index, 1);
          this.dataSource.data = [...this.tableData];
          this.showOptionsModal = false;
          this.fetchEmployeeData();
          this.toastr.success('Item deleted successfully');
        },
        error: (err) => {
          console.error('Delete failed:', err);
          this.toastr.error('Failed to delete item');
        },
        complete: () => this.loaderService.hide(),
      });
  }

  onInsuranceClassChange(event: Event, index: number) {
    // const value = (event.target as HTMLSelectElement).value;
    // this.tableData[index].insuranceClass = value;
    // // You might want to add an API call here to save the change
    // this.loaderService.show();
    // this.http
    //   .post(
    //     `${this.urlReferenceService.currentBaseUrl}/member/${this.crNumber}/${this.tableData[index].idNumber}`,
    //     this.tableData[index]
    //   )
    //   .subscribe({
    //     next: () => {
    //       this.toastr.success('Insurance class updated successfully');
    //     },
    //     error: (err) => {
    //       console.error('Update failed:', err);
    //       this.toastr.error('Failed to update insurance class');
    //     },
    //     complete: () => this.loaderService.hide(),
    //   });
  }

  toggleOptions(
    event: MouseEvent,
    employeeIndex: number | null = null,
    dependentIndex: number | null = null,
    isDependent: boolean = false
  ) {
    event.stopPropagation();
    const rect = (event.target as HTMLElement).getBoundingClientRect();
    this.modalPosition = {
      top: `${rect.bottom + window.scrollY}px`,
      left: `${rect.left}px`,
    };
    this.selectedRowIndex = employeeIndex;
    this.showOptionsModal = this.selectedRowIndex === employeeIndex;
    this.selectedDependentIndex = dependentIndex;
    this.showAddDependentModal = !isDependent;
  }

  get allSelected(): boolean {
    return (
      this.selectedItems.length === this.tableData.length &&
      this.tableData.length > 0
    );
  }

  get noneSelected(): boolean {
    return this.selectedItems.length === 0;
  }

  get partiallySelected(): boolean {
    return !this.allSelected && !this.noneSelected;
  }

  toggleAllCheckboxes(): void {
    if (this.allSelected) {
      this.selectedItems = [];
    } else {
      this.selectedItems = [...this.tableData];
    }
  }

  toggleCheckbox(row: Member): void {
    const index = this.selectedItems.findIndex((item) => item === row);
    if (index > -1) {
      this.selectedItems.splice(index, 1);
    } else {
      this.selectedItems.push(row);
    }
  }

  isSelected(row: Member): boolean {
    return this.selectedItems.includes(row);
  }

  closeOptionsModal() {
    this.showOptionsModal = false;
  }

  back() {
    window.history.back();
  }

  continue() {
    if (!this.isDashboard) {
      if (this.tableData.length === 0) {
        this.toastr.warning('No employees to continue with');
        return;
      }
      this.router.navigate(['/health-declaration'], {
        queryParams: { companyId: this.companyId },
      });
    } else {
      this.router.navigate(['/dashboard/home']);
    }
  }

  formatDate(date: string): string {
    return this.datePipe.transform(date, 'dd-MM-yyyy') || '';
  }

  AddEmployeeAndDependency(
    index: number,
    dependentIndex: number | null = null,
    isEdit: boolean = true,
    isDependent: boolean = false
  ): void {
    const employee = this.tableData[index];
    const existingDependent =
      isDependent && employee.dependentList && dependentIndex !== null
        ? employee.dependentList[dependentIndex]
        : null;

    console.log(
      'Adding/Editing Employee or Dependent:',
      JSON.stringify(existingDependent)
    );
    const dialogRef = this.dialog.open(EmployeeEditComponent, {
      data: {
        member: existingDependent || employee,
        sponsorId: this.companyId,
        isDependent,
        isEdit,
      },
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      console.log('Dialog closed with result:', result);
      if (!result?.onChange) return;

      let body: any;

      if (isDependent) {
        // New dependent
        const newDependent: ApiDependent = {
          firstNameEn: result.nameEnglish,
          lastNameEn: result.nameEnglish,

          nameArabic: result.nameArabic,
          declarationCompleted: false,
          married: result.isMarried,
          gender: result.gender,
          dateOfBirth: result.dateOfBirth,
          idNumber: result.idNumber,
          insuranceClass: result.insuranceClass,
          mobileNumber: result.mobileNumber,
          relation: result.relation,
          employeeId: employee.id ?? employee.employeeId ?? '',
        };

        if (!isEdit) {
          body = {
            ...employee,
            dependentList: [...(employee.dependentList || []), newDependent],
            companyId: this.companyId,
          };
        } else if (isEdit) {
          // Edit dependent
          const updatedDependents = [...(employee.dependentList || [])];
          if (dependentIndex !== null && updatedDependents[dependentIndex]) {
            updatedDependents[dependentIndex] = {
              ...updatedDependents[dependentIndex],
              ...newDependent,
            };
          } else {
            console.warn('Invalid dependent index');
          }

          body = {
            ...employee,
            dependentList: updatedDependents,
            companyId: this.companyId,
          };
        }
      } else {
        // Edit employee
        body = {
          id: isEdit ? employee.id : null,
          idNumber: result.idNumber,
          firstNameEn: result.firstNameEnglish,
          lastNameEn: result.lastNameEnglish,
          nameArabic: result.nameArabic,
          dateOfBirth: result.dateOfBirth,
          mobileNumber: result.mobileNumber,
          insuranceClass: result.insuranceClass,
          jobTitle: result.jobTitle,
          gender: result.gender,
          married: result.isMarried,
          companyId: result.sponsorId,
        };
      }

      console.log('Prepared PATCH body:', body);
      this.loaderService.show();

      this.http
        .patch(`${this.urlReferenceService.currentBaseUrl}/save`, body)
        .pipe(finalize(() => this.loaderService.hide()))
        .subscribe({
          next: () => {
            this.toastr.success('Item updated successfully');
            
            // Mark that insurance class was updated for this company
            console.log('Employee/dependent saved - marking insurance class update for companyId:', this.companyId);
            if (this.companyId) {
              this.quotaTriggerService.markInsuranceClassUpdated(this.companyId.toString());
            } else {
              console.warn('No companyId found - cannot mark insurance class update');
            }
            
            this.fetchEmployeeData();
          },
          error: (err) => {
            this.toastr.error(err.error || 'Failed to update item');
            console.error('Update failed:', err);
          },
        });
    });
  }

  saveItem(index: number) {
    const updatedItem = this.tableData[index];
    this.loaderService.show();
    this.http
      .put(
        `${this.urlReferenceService.currentBaseUrl}/${this.companyId}/employees/${updatedItem.idNumber}`,
        updatedItem
      )
      .subscribe({
        next: () => {
          this.editedRowIndex = null;
          this.toastr.success('Item updated successfully');
        },
        error: (err) => {
          console.error('Update failed:', err);
          this.toastr.error('Failed to update item');
        },
        complete: () => this.loaderService.hide(),
      });
  }

  cancelEdit(index: number) {
    if (this.originalRowData && this.editedRowIndex !== null) {
      this.tableData[index] = { ...this.originalRowData };
      this.dataSource.data = [...this.tableData];
    }
    this.editedRowIndex = null;
  }

  onPageChange(page: number): void {
    this.currentPage = page;
    this.fetchEmployeeData();
  }

  get pages(): number[] {
    return Array.from({ length: this.totalPages }, (_, i) => i);
  }

  getDependents(dependents: any[]) {
    console.log('Dependents:', JSON.stringify(dependents, null, 2));
    return dependents;
  }
}
